import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ApiError } from "../../../api/http";
import { fetchStaffMe, type StaffMeBundle } from "../../../api/staffApi";
import { useAuth } from "../../../state/AuthProvider";
import { staffInitials } from "../staffFormat";
import { SkeletonCard } from "../components/SkeletonCard";
import { StaffAlert } from "../components/StaffAlert";
import { StaffAppShell } from "../components/StaffAppShell";

export function StaffMePage() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [bundle, setBundle] = useState<StaffMeBundle | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        setBundle(await fetchStaffMe());
      } catch (e) {
        setError(e instanceof ApiError ? e.message : "Could not load profile.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const name = bundle?.user.name ?? "Staff";

  return (
    <StaffAppShell title="Me">
      <div className="staff-page">
        {error ? <StaffAlert onDismiss={() => setError(null)}>{error}</StaffAlert> : null}

        {loading ? (
          <SkeletonCard />
        ) : (
          <>
            <div className="staff-me-hero">
              <span className="staff-me-avatar">{staffInitials(name)}</span>
              <h2>{name}</h2>
              <p className="muted">{bundle?.user.email}</p>
              {bundle?.profile.referenceCode ? (
                <p className="staff-me-ref muted">Ref {bundle.profile.referenceCode}</p>
              ) : null}
            </div>

            <nav className="staff-me-menu">
              <Link to="/staff/me/availability" className="staff-me-menu__item">Availability</Link>
              <Link to="/staff/notifications" className="staff-me-menu__item">Notifications</Link>
              <Link to="/staff/me/notification-preferences" className="staff-me-menu__item">
                Notification preferences
              </Link>
              <Link to="/staff/me/time-corrections" className="staff-me-menu__item">Time corrections</Link>
            </nav>

            {bundle && bundle.qualifications.length > 0 ? (
              <section className="staff-section">
                <h3 className="staff-section__title">Qualified roles</h3>
                <ul className="staff-tag-list">
                  {bundle.qualifications.map((q) => (
                    <li key={q.id}>{q.roleName}</li>
                  ))}
                </ul>
              </section>
            ) : null}

            <button
              type="button"
              className="secondary-button staff-me-signout"
              onClick={() => void logout().then(() => navigate("/login"))}
            >
              Sign out
            </button>
          </>
        )}
      </div>
    </StaffAppShell>
  );
}
